import { render, staticRenderFns } from "./navDashboardCard.vue?vue&type=template&id=41245ab4&scoped=true&"
import script from "./navDashboardCard.vue?vue&type=script&lang=js&"
export * from "./navDashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./navDashboardCard.vue?vue&type=style&index=0&id=41245ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41245ab4",
  null
  
)

component.options.__file = "navDashboardCard.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VCardTitle,
  VChip,
  VIcon,
})
